/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userRewards

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import okio.FileSystem
import features.userRewards.internal.UserRewardsUseCase
import features.userRewards.internal.UserRewardsUseCase.Params
import features.userRewards.models.UserRewardsModel


typealias UserRewardsState = CFlow<UserRewardsUseCaseResult?>

typealias UserRewardsUseCaseResult = Result<UserRewardsModel>

fun UserRewardsUseCaseResult.serializeUserRewardsApiResult(): SerializedResult<String> {
    return this.toJsonResult<UserRewardsModel>()
}

/**
 * Serializes [UserRewardsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserRewardsState.serializeUserRewardsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<UserRewardsModel>()
    }.asCFlow()
}

/**
 * Get a list of rewards available to this user. [Api] class
 */
class UserRewardsApi : Api() {

    val userRewardsState: UserRewardsState
        get() = _userRewardsState.asCFlow()

    companion object {
        private val _userRewardsState: MutableStateFlow<UserRewardsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userRewardsUseCase = UserRewardsUseCase()

    /**
     * Get a list of rewards available to this user.
     */
    suspend fun getUserRewards(
        overrideHeaders: Map<String, String>? = null,

    ): Result<UserRewardsModel> {
        /* set state to Loading as soon as function is called */
        _userRewardsState.value = Loading()
        val result = this.userRewardsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _userRewardsState.value = result
            return@userRewardsUseCase result
        }
        return result
    }

}
